import { Controller } from '@hotwired/stimulus'
import { fetchTurbo } from '../utils/fetch-turbo'

// Отметка «взнос оплачен» в таблице турнира (только для организатора).
export default class TournamentPaidController extends Controller {
  static values = { url: String }

  async toggle(event) {
    const checked = event.target.checked
    const response = await fetchTurbo(this.urlValue, {
      method: 'PATCH',
      body: JSON.stringify({ paid: checked })
    })
    if (!response.ok) event.target.checked = !checked
  }
}
